import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {EquipementService} from "../../../services/equipement.service";
import {FormHelperService} from "../../../services/form-helper.service";
import {ToastService} from "../../../services/toast.service";
import {LogementService} from "../../../services/logement.service";
import {Logement} from "../../../models/logement";
import {Router} from "@angular/router";

@Component({
    selector: 'app-equipement-new',
    templateUrl: './equipement-new.component.html',
    styleUrls: ['./equipement-new.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquipementNewComponent implements OnInit {

  logement: Logement;
  form: UntypedFormGroup;
  image: File;
  notice: File;
  isSubmited = false;

  constructor(
    private fb: UntypedFormBuilder,
    private fh: FormHelperService,
    private equipementService: EquipementService,
    private logementService: LogementService,
    private toastService: ToastService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.logementService.logementCourant.subscribe(logement => {
      this.logement = logement;
    });

    this.form = this.fb.group({
      nom: [''],
      description: [''],
      image: [''],
      reference: [''],
      urlFabriquant: [''],
      notice: [''],
      entretienFaitPar: [0],
      periodiciteEntretien: [''],
      conseilMiseEnRoute: [''],
      conseilEntretien: [''],
      conseilsCasDePanne: ['']
    });
  }

  uploadFile(event, target) {
    this[target] = (event.target as HTMLInputElement).files[0];
  }

  save() {
    if (this.isSubmited === true) {
      return;
    }
    this.isSubmited = true;

    const equipment = this.form.getRawValue();
    const formData = new FormData();
    formData.append('nom', equipment.nom);
    formData.append('description', equipment.description);
    formData.append('reference', equipment.reference);
    formData.append('urlFabriquant', equipment.urlFabriquant);
    formData.append('entretienFaitPar', equipment.entretienFaitPar);
    formData.append('periodiciteEntretien', equipment.periodiciteEntretien);
    formData.append('conseilMiseEnRoute', equipment.conseilMiseEnRoute);
    formData.append('conseilEntretien', equipment.conseilEntretien);
    formData.append('conseilsCasDePanne', equipment.conseilsCasDePanne);
    if (this.image) {
      formData.append('image[binaryContent]', this.image);
    }
    if (this.notice) {
      formData.append('notice[binaryContent]', this.notice);
    }

    this.equipementService.createIndividualEquipment(this.logement, formData).then(response => {
      this.isSubmited = false;
      if (response.status == 'error') {
        this.fh.setSymfonyFormErrors(this.form, response.errors, true);
        return;
      }
      this.toastService.show(response.message, {classname: 'toast-' + response.status});
      this.router.navigate(['/mes-equipements/ajouter']);
    });
  }

}
